module.exports = __webpack_public_path__ + "static/media/explore-step4-img-2.dcf17157.png";